__turbopack_context__.v({
  "closeIcon": "iVXRCa_closeIcon",
  "closeIcon__active": "iVXRCa_closeIcon__active",
  "container": "iVXRCa_container",
  "container__active": "iVXRCa_container__active",
  "input": "iVXRCa_input",
  "input__active": "iVXRCa_input__active",
  "searchIcon": "iVXRCa_searchIcon",
  "shimmer": "iVXRCa_shimmer",
  "text-bar-sweep": "iVXRCa_text-bar-sweep",
});
